// Pure preflight guards shared by the Commission-tab Delete / Adjust modals and
// createAdminAdjustment. They run BEFORE any write and only ever refuse.
//
//  - corrections table missing while commission was already paid (migration 0031
//    not run): the invoice change would succeed and the clawback line could not be
//    recorded afterwards, so refuse first.
//  - legacy-only paid invoice: its commission was paid through the per-device
//    localStorage payout (never migrated to rep_commission_payments), so there is
//    no ledger row to correct against. Refuse until the legacy backfill ran.

export const CORRECTIONS_TABLE_MISSING_MESSAGE =
  "Commission corrections are not set up yet, and this invoice's commission was already paid. Run migration 0031_rep_commission_corrections.sql in the Supabase SQL editor first, then try again. Nothing was changed.";

export function legacyPaidMessage(invoiceId) {
  return `The commission for invoice ${invoiceId} was paid before the payouts were migrated to Supabase, so it exists only as a legacy payout on one browser and no correction can be worked out yet. Open the Commission tab on the browser that holds the legacy payout so the migration completes, then try again. Nothing was changed.`;
}

/**
 * @param {{invoiceId:string, paidRowsCount:number, corr:{ok?:boolean, missingTable?:boolean}|null, legacyPaid?:boolean}} p
 * @returns {{ok:true}|{ok:false, code:'corrections_missing'|'legacy_paid', message:string}}
 */
export function preflightCorrectionState(p) {
  const { invoiceId, paidRowsCount, corr, legacyPaid } = p || {};
  if (corr && corr.missingTable && Number(paidRowsCount) > 0) {
    return { ok: false, code: "corrections_missing", message: CORRECTIONS_TABLE_MISSING_MESSAGE };
  }
  if (legacyPaid) {
    return { ok: false, code: "legacy_paid", message: legacyPaidMessage(invoiceId) };
  }
  return { ok: true };
}

/** True when the invoice id is in the tab's legacy-paid set (Set, array or undefined). */
export function isLegacyPaid(legacyPaidIds, invoiceId) {
  if (!legacyPaidIds || invoiceId == null) return false;
  const id = String(invoiceId);
  if (legacyPaidIds instanceof Set) return legacyPaidIds.has(id);
  if (Array.isArray(legacyPaidIds)) return legacyPaidIds.map(String).includes(id);
  return false;
}
